/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgChartLineArea = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="m12.3 4.4-2.9 2L4 4.3V2H2v20h20V6.2l-9.7-1.8zM20 20H4v-4.9l6.1 3 4.5-3 3.6 2.1 1.8-1.8V20zm0-7.4-2.2 2.2-3.4-1.9-4.5 3-5.9-3v-.6l6.1 1.3 5.6-2.5H20v1.5zM20 9h-4.7l-5.4 2.5L4 10.2V6.5l5.6 2.2 3.1-2.1L20 7.8V9z"
      fill="currentcolor"
    />
  </Icon>
);
export { SvgChartLineArea as ChartLineArea };
